import React from "react";
import { useNavigate } from "react-router-dom";
import { User, Layers, Users, Filter } from "lucide-react";

/**
 * AdminTargetInfoCard (Improved)
 * - Clean, strong admin UI
 * - Icons + clear hierarchy
 * - Handles LEVEL_1 .. LEVEL_7 formatting
 * - Supervisor icon navigates to admin profile page
 */
export default function AdminTargetInfoCard({ adminPayload }) {
  const navigate = useNavigate();

  if (!adminPayload) return null;

  const {
    targetedFaculty,
    targetedGender,
    targetedLevel,
    supervisorId,
  } = adminPayload;

  const formatLevels = (levels) => {
    if (!levels) return "—";
    const arr = Array.isArray(levels) ? levels : [levels];
    return arr
      .map((l) => l.replace("LEVEL_", "Level "))
      .join(", ");
  };

  const Item = ({ icon: Icon, label, value, onClick }) => (
    <div
      className={`d-flex align-items-start gap-3 p-3 rounded-3 bg-light border ${
        onClick ? "cursor-pointer" : ""
      }`}
      onClick={onClick}
    >
      <div className="icon-box bg-white shadow-sm rounded-circle d-flex align-items-center justify-content-center" style={{ width: 42, height: 42 }}>
        <Icon size={20} className="text-primary" />
      </div>
      <div className="flex-grow-1">
        <div className="small text-muted">{label}</div>
        <div className="fw-semibold text-dark mt-1">{value || "—"}</div>
      </div>
    </div>
  );

  return (
    <div className="mt-3">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h6 className="fw-bold mb-0 text-dark">Targeting Rules</h6>
        <span className="bg-primary-subtle text-primary">Admin Only</span>
      </div>

      <div className="row g-3">
        <div className="col-12 col-md-6 col-xl-3">
          <Item
            icon={Users}
            label="Targeted Faculty"
            value={targetedFaculty}
          />
        </div>

        <div className="col-12 col-md-6 col-xl-3">
          <Item
            icon={Filter}
            label="Targeted Gender"
            value={targetedGender}
          />
        </div>

        <div className="col-12 col-md-6 col-xl-3">
          <Item
            icon={Layers}
            label="Targeted Levels"
            value={formatLevels(targetedLevel)}
          />
        </div>

        <div className="col-12 col-md-6 col-xl-3">
          <Item
            icon={User}
            label="Supervisor Profile"
            value="View Profile"
            onClick={() =>
              navigate(`/admin/view-user-profile/${supervisorId}`)
            }
          />
        </div>
      </div>
    </div>
  );
}
